export const useConstants = () => ({
    meetingUsUrl: 'https://calendly.com/leansoft-inc/30min',
    videoYoutubeTestimonialByAnthonyId: 'nWolaeQQ2I0',
});
